import { array, number, object, setLocale } from 'yup'

import {
  RequestTicketStatusSync,
  RequestTicket,
  RequestTicketClassType
} from 'src/types'

function getInitialValues(): RequestTicket & {
  receiver_id?: string
} {
  return {
    active: true,
    class_type: RequestTicketClassType.TITLE,
    cost: 0,
    is_toodopay: false,
    receiver_id: '*',
    request_id: null,
    request_ticket_id: null,
    request_ticket_number: null,
    request_ticket_receipts: [],
    request_ticket_title_advances: [
      {
        active: true,
        request_ticket_title_advance_id: null,
        request_ticket_title_advance_number: null,
        situation: null,
        currency_id: null,
        financial_resource_id: null,
        cost: 0,
        exchange_rate: 1,
        amount: 0
      }
    ],
    request_ticket_type: 'ADVANCE',
    request_ticket_user_data: [],
    status: null,
    sync_status: RequestTicketStatusSync.NOT_SYNC,
    user_id: null,
    tenant_id: null
  }
}

function getValidationSchema() {
  setLocale({
    mixed: {
      required: 'common.required',
      notType: 'common.required'
    }
  })
  return object().shape({
    request_ticket_title_advances: array().of(
      object().shape({
        amount: number()
          .required()
          .min(1, 'web.services.advances.form.exchange-rate.min'),
        currency_id: number().required().typeError(),
        exchange_rate: number()
          .required()
          .min(1, 'web.services.advances.form.exchange-rate.min'),
        financial_resource_id: number().typeError().required()
      })
    )
  })
}

export { getInitialValues, getValidationSchema }
